export default __webpack_public_path__ + "static/media/fad-logo-reason.1bc0948f.svg";